import {dcbConfig} from "../config";
import axios from "axios";

const headers = {Authorization: `Basic UGVucm9zZV9HYW1pbmc6Qm83c2pIeVQ4MGdB`};

export default class DcbService {
    static async decryptUserMsisdn(encryptedMsisdn) {
        try {
            const response = await axios.post(`${dcbConfig.host}/decrypt-msisdn`, {
                encryptedMsisdn,
            }, {headers});
            return response.data;
        } catch (error) {
            return {authError: true, error: error.message};
        }
    }
}
